import { Field, Formik, Form } from 'formik';
import Close from '@material-ui/icons/Close';
import withStyles from '@material-ui/styles/withStyles';

import { Grid, IconButton, InputAdornment } from '@material-ui/core';

import AutoSaveFormik from 'app/components/form/formik/AutoSaveFormik';
import TextFieldFormik from 'app/components/form/formik/TextFieldFormik';

export const Filters = {
  TEXT_SEARCH: 'textSearch',
  SERIAL_SEARCH: 'serialSearch',
};

const shouldSubmit = ({ isValid }) => isValid;

const CablesFilter = ({ classes, onSubmit, initialValues }) => (
  <Formik enableReinitialize onSubmit={onSubmit} initialValues={initialValues}>
    <Form>
      <AutoSaveFormik timeout={1000} shouldSubmit={shouldSubmit}>
        <Grid container className={classes.root}>
          <Grid container spacing={2} alignItems="center">
            <Grid item container xs spacing={2} wrap="nowrap">
              <Grid xs item>
                <Field name={Filters.TEXT_SEARCH}>
                  {({ form, ...formik }) => (
                    <TextFieldFormik
                      form={form}
                      margin="none"
                      label="Name"
                      placeholder="Search Cable..."
                      inputProps={{
                        maxLength: 100,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              title="Remove"
                              onClick={() =>
                                form.setFieldValue(
                                  Filters.TEXT_SEARCH,
                                  initialValues[Filters.TEXT_SEARCH],
                                )
                              }
                            >
                              <Close fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      {...formik}
                    />
                  )}
                </Field>
              </Grid>
              <Grid xs item>
                <Field name={Filters.SERIAL_SEARCH}>
                  {({ form, ...formik }) => (
                    <TextFieldFormik
                      form={form}
                      margin="none"
                      label="Serial number"
                      placeholder="Search Cables By Serial number..."
                      inputProps={{
                        maxLength: 100,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              title="Remove"
                              onClick={() =>
                                form.setFieldValue(
                                  Filters.SERIAL_SEARCH,
                                  initialValues[Filters.SERIAL_SEARCH],
                                )
                              }
                            >
                              <Close fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      {...formik}
                    />
                  )}
                </Field>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AutoSaveFormik>
    </Form>
  </Formik>
);

const styles = {
  root: {
    marginBottom: 15,
    paddingTop: 15,
  },
  leftIcon: {
    marginRight: 10,
  },
};

export default withStyles(styles)(CablesFilter);
